import api from './api';

/**
 * Generate AI ratings for all processes
 */
export async function generateRatings(customerId, processes, context) {
  const response = await api.post('/api/ai/generate-ratings', {
    customerId,
    processes,
    context
  });
  return response.data;
}

/**
 * Rewrite introduction with AI
 */
export async function rewriteIntroduction(customerId, context) {
  const response = await api.post('/api/ai/rewrite-introduction', {
    customerId,
    context
  });
  return response.data;
}

/**
 * Rewrite approach with AI
 */
export async function rewriteApproach(customerId, context) {
  const response = await api.post('/api/ai/rewrite-approach', {
    customerId,
    context
  });
  return response.data;
}

/**
 * Rewrite recommended approach with AI
 */
export async function rewriteRecommendedApproach(customerId, context) {
  const response = await api.post('/api/ai/rewrite-recommended-approach', {
    customerId,
    context
  });
  return response.data;
}

/**
 * Rewrite process summary with AI
 */
export async function rewriteProcessSummary(processName, originalSummary, context) {
  const response = await api.post('/api/ai/rewrite-process-summary', {
    processName,
    originalSummary,
    context
  });
  return response.data;
}

/**
 * Rescore a single process with AI
 */
export async function rescoreProcess(process, context) {
  const response = await api.post('/api/ai/rescore-process', {
    process,
    context
  });
  return response.data;
}
